"use client"

import { Link } from "react-router-dom"
import { useForm } from "react-hook-form"
import Form from "react-bootstrap/Form"
import { useState } from "react"
import { useTranslations } from "../../translations"

const Step1 = ({ defaultValues, next, step }) => {
  const { handleSubmit, watch, setValue } = useForm({
    defaultValues,
  })
  const role = watch("role")
  const [required, setRequired] = useState(null)
  const [select, setSelect] = useState("")
  const { t } = useTranslations()

  const onSubmit = (data) => {
    if (!data.role) {
      setRequired(t("roleRequired"))
      return
    }
    next(data, step)
  }

  const handleChange = (e) => {
    setValue("role", e.target.value)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Link to={"/"}><img src="/assets/img/landing-images/MiABC-33.png" alt="MiABC Logo" className="auth-logo" /></Link>
      <h3 className="title">{t("createAccount")}</h3>
      <Form.Select aria-label="select" className="form-select" onChange={handleChange} value={role ? role : ""}>
        <option value="">{t("selectRolePlaceholder")}</option>
        <option value="Padre">{t("parent")}</option>
      </Form.Select>
      <div className="text-danger mb-2">{required ? required : ""}</div>
      <input type="submit" className="btn" value={t("next")} />
      <div className="mt-3">
        <Link to="/login" className="text-link-1">
          {t("alreadyHaveAccount")} <strong>{t("signIn")}</strong>
        </Link>
      </div>
      <p className="text-link-1 mt-3">
        {t("privacyRegisterText")}{" "}
        <Link to="/privacy" target="_blank" className="d-inline">
          {t("privacyPolicy")}
        </Link>
      </p>
    </form>
  )
}

export default Step1
